const video = $('#home-background-video');
$(document).ready(() => {
  if (video.length > 0) {
    resize();
  }
});

$(window).on("load", () => {
  if (video.length > 0) {
    video.append(`
      <source
      src="${THEME_URL}media/video/background.webm"
      type="video/webm" />
      <source
      src="${THEME_URL}media/video/background.mp4"
      type="video/mp4" />
    `);
    video[0].load();
    video[0].play();
  }
});

$(window).on('resize', () => {
  if (video.length > 0) {
    resize();
  }
});

const resize = () => {
  const width = $(window).width();
  const height = $(window).height();
  const windowRatio = width / height;
  if (windowRatio > 16 / 9) {
    video.css('height', 'auto');
    video.css('width', width);
  } else {
    video.css('width', 'auto');
    video.css('height', height);
  }
}



// WEBPACK FOOTER //
// ./js/inc/home-video.js